import { useCallback, useEffect, useRef, useState } from 'react';
import { loadRaidSeasonSetup } from '../api/raidSeasonApi.js';

export function useRaidSeason() {
  const [setup, setSetup] = useState({ seasons: [], selectedSeason: null });
  const [loading, setLoading] = useState(true);
  const [notice, setNotice] = useState({ type: '', message: '' });
  const requestId = useRef(0);
  const refresh = useCallback(async (seasonNo = null) => {
    const id = ++requestId.current;
    setLoading(true);
    try {
      const next = await loadRaidSeasonSetup(seasonNo);
      if (id !== requestId.current) return;
      setSetup(next);
      setNotice({ type: '', message: '' });
    } catch (error) {
      if (id === requestId.current) setNotice({ type: 'error', message: error.message });
    } finally {
      if (id === requestId.current) setLoading(false);
    }
  }, []);
  useEffect(() => {
    refresh();
    const handler = () => refresh();
    window.addEventListener('dororaid:raid-season-changed', handler);
    return () => {
      requestId.current += 1;
      window.removeEventListener('dororaid:raid-season-changed', handler);
    };
  }, [refresh]);
  return { ...setup, loading, notice, selectSeason: refresh };
}
